enum PermissionEnum {
  OWN = 'OWN',
  ORGANIZATION = 'ORGANIZATION',
  SCHOOL = 'SCHOOL',
  COURSE = 'COURSE'
}

export default PermissionEnum
